import React, { useEffect, useRef } from "react";
import "./About.css";
import aboutImg1 from "../../Images/aboutImg1.png";
import aboutIcon2 from "../../Images/Icons/aboutIcon2.png";
import aboutIcon3 from "../../Images/Icons/aboutIcon3.png";
import aboutIcon4 from "../../Images/Icons/aboutIcon4.png";
import aboutImg5 from "../../Images/aboutImg5.png";
import Add from '../../Components/Home/add';
const About = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
            entry.target.classList.remove("animate-hidden");

            // 👇 Stop observing once it's visible (run only once)
            observerRef.current.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const animatedElements = document.querySelectorAll(
      ".fade-in, .slide-up, .slide-left, .slide-right, .zoom-in, .stagger-item, .rotate-in, .bounce-in"
    );

    animatedElements.forEach((el) => {
      el.classList.add("animate-hidden");
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="aboutSection">
      <div className="aboutHeroBlock">
        <div className="aboutText fade-in">
          <h2>About Career Restorer</h2>
          <p>
            Driven by purpose and powered by partnerships, Career Restorer helps
            students launch meaningful careers across industries. From
            skill-building to placement, we bridge ambition with opportunity.
          </p>
        </div>
        <div className="aboutImg zoom-in">
          <img src={aboutImg1} alt="aboutImg1" />
        </div>
      </div>

      <div className="visionBlock">
        <div className="visionCards slide-up">
          <img src={aboutIcon2} alt="careerPurpose" />
          <div className="visionCardsText">
            <h3>Our Purpose</h3>
            <p>
              We restore career confidence in students by connecting them with
              companies that value potential, passion, and progress. Career
              Restorer builds futures that truly matter.
            </p>
          </div>
        </div>
        <div
          className="visionCards slide-up"
          style={{ transitionDelay: "0.2s" }}
        >
          <img src={aboutIcon3} alt="careerVision" />
          <div className="visionCardsText">
            <h3>Our Vision</h3>
            <p>
              To be India’s most trusted career placement platform, empowering
              learners with meaningful opportunities across IT and Non-IT
              sectors. We envision a future where education flows seamlessly
              into employment.
            </p>
          </div>
        </div>
        <div
          className="visionCards slide-up"
          style={{ transitionDelay: "0.4s" }}
        >
          <img src={aboutIcon4} alt="careerCommitment" />
          <div className="visionCardsText">
            <h3>Our Commitment</h3>
            <p>
              We stand by every student's journey from preparation to placement.
              Career Restorer delivers trusted guidance, industry-aligned
              opportunities, and a placement experience that is personal,
              professional, and empowering.
            </p>
          </div>
        </div>
      </div>
      

      <div className="aboutHeroBlock">
        <div className="aboutImg rotate-in">
          <img src={aboutImg5} alt="aboutImg1" />
        </div>
        <div className="aboutText slide-left">
          <h2>Empowering Students, One Placement at a Time</h2>
          <p>
            At Career Restorer, we believe every student deserves a chance to
            succeed. Our platform connects learners with trusted companies
            across IT and Non-IT sectors, helping them turn potential into
            progress through meaningful career opportunities.
          </p>
        </div>
      </div>

      <div className="aboutVoices">
        <h2 className="fade-in">Student Voices</h2>
        <p className="fade-in">
          Hear from students who found their career path through Career
          Restorer.
        </p>
        <div className="aboutVoiceBlock">
          {[
            {
              initials: "MD",
              name: "Mohan Das",
              text: "Career Restorer delivered exceptional project execution for my academic real-time project, showcasing seamless coordination and innovative cloud solutions. Their user-friendly platform streamlined workflows, ensuring timely task completion and enhanced collaboration. Real-time updates and robust support minimized errors and boosted efficiency. Highly recommended for academic projects requiring precision and scalability!",
            },
            {
              initials: "RS",
              name: "Riya Sharma",
              text: "Had a great experience working with Career Restorer for my academic project. Their team was super supportive and the cloud platform made everything so easy to manage. Tasks were completed on time, and the real-time updates really helped avoid last-minute confusion. Overall, their service made my project run smoothly without stress. Highly recommend them if you want your project handled professionally and efficiently.",
            },
            {
              initials: "S",
              name: "Satish",
              text: "Our experience with Career Restorer was excellent. The teaching was clear, practical, and easy to follow. The trainers were supportive, and the sessions were well-structured. We gained strong knowledge and hands-on skills, making it a great place for learning. Highly recommended!",
            },
            {
              initials: "AJ",
              name: "Aastha Jain",
              text: "Career Restorer corporate office training is top-notch! The expert-led sessions and hands-on learning approach helped our team gain practical skills in commerce field like banking operation finance etc. The training was engaging, interactive to our organizations needs. Highly recommended",
            },
            {
              initials: "SK",
              name: "Shaheeda Khanum",
              text: "The hiring process at Career Restorer was structured and professional. Communication was timely, and each round was well-coordinated. The interviewers were courteous and focused on both technical knowledge and cultural fit. Overall, it was a smooth and transparent experience that reflected the company's commitment to quality talent.",
            },
          ].map((student, index) => (
            <div
              key={index}
              className="aboutVoiceCard bounce-in"
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="voiceHeader">
                <p>{student.initials}</p>
                <h3>{student.name}</h3>
              </div>
              <p>{student.text}</p>
            </div>
          ))}
        </div>
      </div>
<Add/>
      <div className="placeSection">
        <h1 className="zoom-in">Ready to Get Placed?</h1>
        <p className="fade-in">
          Join Career Restorer and take the first step toward your future.
          Whether you're a student or a hiring partner, we're here to help you
          succeed.
        </p>
        <div className="placeBtn">
          <a href="/jobSub">
            <button className="slide-left">Explore Jobs</button>
          </a>
          <a href="/training">
            <button className="slide-right">Explore Training</button>
          </a>
        </div>
      </div>
      
    </div>
  );
};

export default About;
